import React from 'react'
import { CustomCard } from 'src/components'
import { useTranslation } from 'next-i18next'
import MassiveCalculationSteps from '../MassiveCalculationSteps/MassiveCalculationSteps'
import MassiveCalculationStepSwitch from '../MassiveCalculationStepSwitch/MassiveCalculationStepSwitch'

const MassCalculationCard: React.FC = () => {
  const { t } = useTranslation()

  return (
    <CustomCard cardTitle={t('admin.MassiveCalculate.CardTitle')}>
      <MassiveCalculationStepSwitch />
      <MassiveCalculationSteps />
    </CustomCard>
  )
}

export default MassCalculationCard
